// extracted by mini-css-extract-plugin
export default {"container":"Name_container__YgKEv","content":"Name_content__Ru+vV","textContainer":"Name_textContainer__WM4QZ"};